import { useEffect, useState } from 'react'
import { PAGE_STATE, PERMISSION } from '../../helpers'
import { useAffiliation } from '../../hooks'
import { StoryEdit } from './StoryEdit'
import { StoryDisplay } from './StoryDisplay'
import { useActions } from '../../store'

export const SingleStoryView = ({ category, story }) => {
  const { affiliation } = useAffiliation()
  const permissions = affiliation?.permissions || []
  const canEdit = permissions.includes(PERMISSION.EDIT)
  // new story -> editing, otherwise user toggles to edit
  const [editing, setEditing] = useState(canEdit && !story.id)
  const [title, setTitle] = useState(story?.title)
  const [content, setContent] = useState(story?.content)
  const changed = title !== story?.title || content !== story?.content
  const { setPageState, setDisabled } = useActions()

  useEffect(() => {
    setPageState(canEdit && editing ? PAGE_STATE.EDIT : PAGE_STATE.READ)
  }, [canEdit, editing, setPageState])

  useEffect(() => {
    setDisabled(changed)
  }, [changed, setDisabled])

  useEffect(() => {
    // Sync local state with story prop when story changes
    setTitle(story?.title || '')
    setContent(story?.content || '')
  }, [story])

  useEffect(() => {
    return () => {
      setPageState(PAGE_STATE.DEFAULT)
      setDisabled(false)
    }
  }, [setPageState, setDisabled])

  const onToggleEdit = () => canEdit && setEditing(!editing)

  return canEdit && editing ? (
    <StoryEdit
      {...{
        category,
        story,
        onToggleEdit,
        title,
        setTitle,
        content,
        setContent,
        changed
      }}
    />
  ) : (
    <StoryDisplay
      {...{ category, story, onToggleEdit, title, content, changed }}
    />
  )
}
